import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Timer = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 20px auto;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

const TimeDisplay = styled.div`
  text-align: center;
  
  .watch {
    font-size: 2.5rem;
    font-weight: bold;
    color: #4A6CF7;
    display: block;
  }
  
  h4 {
    margin: 5px 0 0;
    color: #666;
    font-size: 0.9rem;
  }
`;

const Countdown = ({ until, label = "Focus time", onComplete }) => {
  const [countDown, setCountDown] = useState(until * 60);
  const [runTimer, setRunTimer] = useState(true);
  
  useEffect(() => {
    let timerId;
    
    if (runTimer) {
      timerId = setInterval(() => {
        setCountDown((prevCount) => {
          if (prevCount <= 0) {
            clearInterval(timerId);
            setRunTimer(false);
            return 0;
          }
          return prevCount - 1;
        });
      }, 1000);
    }

    return () => {
      if (timerId) {
        clearInterval(timerId);
      }
    };
  }, [runTimer]);

  useEffect(() => {
    if (countDown === 0 && runTimer) {
      setRunTimer(false);
      if (onComplete) {
        onComplete();
      } else {
        alert("Congratulations on completing your task! 🎉");
      }
    }
  }, [countDown, runTimer, onComplete]);

  const seconds = String(countDown % 60).padStart(2, '0');
  const minutes = String(Math.floor(countDown / 60)).padStart(2, '0');

  return (
    <Timer>
      <TimeDisplay>
        <h4>{label}</h4>
        <span className="watch">{minutes}</span>
        <h4>minutes</h4>
      </TimeDisplay>
      <TimeDisplay>
        <span className="watch">{seconds}</span>
        <h4>seconds</h4>
      </TimeDisplay>
    </Timer>
  );
};

export default Countdown;
